import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
import PublicationCard from "../../components/publicationsCard/PublicationCard";
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import {
  greeting,
  projectsHeader,
  publicationsHeader,
  majorProjects,
  publications,
} from "../../portfolio.js";
import ProjectsData from "../../shared/opensource/projects.json";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

class Projects extends Component {
  render() {
    const theme = this.props.theme;
    const githubRepos = ProjectsData.data || [];
    const hasGithubRepos = githubRepos.length > 0;
    const hasPublications = publications.data.length > 0;

    return (
      <div className="projects-main">
        <Header theme={theme} />
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                {/* <img
											src={require(`../../assets/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>

        {/* Publications  */}
        {/* <h1>Technocrats</h1> */}

        <h1 className="majorprojects-header" style={{ color: theme.text }}>
          Major Projects
        </h1>

        {majorProjects.projects.map((project, index) => {
          const hasScreenshots =
            project.screenshots && project.screenshots.length > 0;
          const isAppStoreLink =
            project.link &&
            /apps\.apple\.com|itunes\.apple\.com/.test(project.link);
          const isPlayStoreLink =
            project.link && /play\.google\.com/.test(project.link);
          const isWebLink =
            project.link && !isAppStoreLink && !isPlayStoreLink;
          const statusStat = (project.stats || []).find(
            (s) => s.label && s.label.toLowerCase() === "status"
          );
          const isInDevelopment =
            statusStat && /development|coming|wip/i.test(statusStat.value);
          const banner = !hasScreenshots
            ? isInDevelopment
              ? {
                  variant: "in-development",
                  emoji: "🚀",
                  label: "In Development",
                  subline: "Coming soon to the App Store",
                }
              : isPlayStoreLink && !isAppStoreLink
              ? {
                  variant: "ios-coming-soon",
                  iconClass: "fab fa-apple",
                  label: "Coming to iOS",
                  subline: "Live on Google Play today — App Store launch soon",
                }
              : isWebLink
              ? {
                  variant: "live-web",
                  emoji: "🌐",
                  label: "Live",
                  subline: "Try it online",
                  cta: { url: project.link, text: "Visit website" },
                }
              : {
                  variant: "default",
                  emoji: "✨",
                  label: project.title.split("—")[0].trim(),
                  subline: project.description,
                }
            : null;

          return (
            <div
              key={index}
              className="majorProject"
              style={{ background: theme.highlight }}
            >
              <div className="majorProject-info">
                <h2 className="project-title" style={{ color: theme.text }}>
                  {project.title}
                </h2>
                <p className="project-description">{project.description}</p>

                {project.stats && project.stats.length > 0 && (
                  <ul className="project-stats-list">
                    {project.stats.map((stat, idx) => (
                      <li key={idx} className="project-stat">
                        <span className="project-stat-value">{stat.value}</span>
                        <span className="project-stat-label">{stat.label}</span>
                      </li>
                    ))}
                  </ul>
                )}

                {project.tools && project.tools.length > 0 && (
                  <ul className="project-tools-list">
                    {project.tools.map((tool, idx) => (
                      <li key={idx}>{tool}</li>
                    ))}
                  </ul>
                )}

                {project.roles && project.roles.length > 0 && (
                  <>
                    <p className="project-roles-heading">My Role</p>
                    <ul className="project-roles-list">
                      {project.roles.map((role, idx) =>
                        role ? <li key={idx}>{role}</li> : null
                      )}
                    </ul>
                  </>
                )}

                {(isAppStoreLink || isPlayStoreLink) && (
                  <a
                    className={`appstore-button ${
                      isPlayStoreLink ? "appstore-button--play" : ""
                    }`}
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={
                      isAppStoreLink
                        ? `View ${project.title} on the App Store`
                        : `Get ${project.title} on Google Play`
                    }
                  >
                    <i
                      className={
                        isAppStoreLink ? "fab fa-apple" : "fab fa-google-play"
                      }
                      aria-hidden="true"
                    ></i>
                    {isAppStoreLink
                      ? "View on App Store"
                      : "Get on Google Play"}
                  </a>
                )}
              </div>

              {hasScreenshots && (
                <div className="screenshots">
                  <h3 style={{ color: theme.text }}>Screenshots</h3>
                  <div className="scroll-container">
                    {project.screenshots.map((screenshot, idx) =>
                      screenshot ? (
                        <img
                          key={idx}
                          src={require(`../../assets/projectSS/${screenshot}`)}
                          alt={`${project.title} screenshot ${idx + 1}`}
                          className="project-screenshot"
                          loading="lazy"
                        />
                      ) : null
                    )}
                  </div>
                </div>
              )}

              {banner && (
                <div
                  className={`project-banner project-banner--${banner.variant}`}
                  role="img"
                  aria-label={`${project.title} ${banner.label}`}
                >
                  <div className="project-banner-emoji" aria-hidden="true">
                    {banner.iconClass ? (
                      <i className={banner.iconClass}></i>
                    ) : (
                      banner.emoji
                    )}
                  </div>
                  <div className="project-banner-label">{banner.label}</div>
                  {banner.subline && (
                    <div className="project-banner-subline">
                      {banner.subline}
                    </div>
                  )}
                  {banner.cta && (
                    <a
                      className="project-banner-cta"
                      href={banner.cta.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {banner.cta.text}
                      <span aria-hidden="true"> →</span>
                    </a>
                  )}
                </div>
              )}
            </div>
          );
        })}

        {hasGithubRepos && (
          <>
            <div className="repo-cards-div-main">
              {githubRepos.map((repo) => (
                <GithubRepoCard repo={repo} theme={theme} />
              ))}
            </div>
            <Button
              text={"More Projects"}
              className="project-button"
              href={greeting.githubProfile}
              newTab={true}
              theme={theme}
            />
          </>
        )}

        {hasPublications && (
          <>
            <div className="basic-projects">
              <Fade bottom duration={2000} distance="40px">
                <div className="publications-heading-div">
                  <div className="publications-heading-text-div">
                    <h1
                      className="publications-heading-text"
                      style={{ color: theme.text }}
                    >
                      {publicationsHeader.title}
                    </h1>
                    <p
                      className="projects-header-detail-text subTitle"
                      style={{ color: theme.secondaryText }}
                    >
                      {publicationsHeader["description"]}
                    </p>
                  </div>
                </div>
              </Fade>
            </div>
            <div className="repo-cards-div-main">
              {publications.data.map((pub) => (
                <PublicationCard pub={pub} theme={theme} />
              ))}
            </div>
          </>
        )}

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
